<template>
  <div class="shieldMain">
    <div class="vip">
      <p>查看价值数据</p>
      <p>尽在高级权限</p>
      <div>
        <el-button @click="vip" class="dialog-tologin">升级SVIP</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../../../src/assets/script/config/";
import { mapState } from "vuex";
export default {
  name: "shieldUpgrade",
  data() {
    return {
      token: ""
    };
  },
  computed: {
    ...mapState("user", ["userToken"])
  },
  mounted() {
    this.token = this.userToken;
  },
  methods: {
    vip() {
      let returnl = config.paySVipUrl.format(
        encodeURIComponent(config.buySvipUrl),
        this.token
      );
      if (this.token === "") {
        this.insertConfig.showLoginMessage(
          true,
          "您当前账号暂未登录，请登录账号享更多权限",
          ""
        );
        return;
      }
      window.open(returnl);
    }
  },
  watch: {
    userToken: {
      handler(val) {
        if (val) {
          this.token = val;
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
.shieldMain {
  background-color: #fffaf4;
  width: 160px;
  height: calc(100% - 590px);
  text-align: center;
  margin: 0 auto;
  .vip {
    position: absolute;
    top: 30%;
    left: 50%;
    font-size: 15px;
    font-weight: 600;
    margin-left: -45px;
    p {
      line-height: 20px;
    }
    div {
      margin-top: 10px;
    }
  }
  .dialog-tologin {
    text-align: center;
    background-color: @theme-color;
    color: white;
    border-radius: 20px;
    padding: 7px 15px;
  }
}
</style>
